import { Box, Grid, Text } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const Loading = memo(() => {
    return (
        <Box spacing='12 0'>
            <Grid gridTemplateColumns='max-content auto' columnGap={16}>
                <Skeleton width={28} height={28} />

                <Grid rowGap={8}>
                    <Text font='label' fontSize='small'>
                        <Skeleton inline width='50%' />
                    </Text>

                    <Grid rowGap={4}>
                        {range(3).map((index) => (
                            <Text key={index} font='label' fontSize='xsmall'>
                                <Skeleton inline width='30%' />
                            </Text>
                        ))}
                    </Grid>

                    <Skeleton height={16} width='90%' />
                </Grid>
            </Grid>
        </Box>
    );
});

Loading.displayName = 'Loading';
